import { Component, inject } from '@angular/core';
import { Script, ScriptService } from '../../../service/script.service';
import { ScriptCardComponent } from "../../../helper/script-card/script-card.component";
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { AccountService } from '../../../service/account.service';
import { IconComponent } from "../../../helper/icon/icon.component";
import { ScriptSunsetBannerComponent } from "../../../helper/script-sunset-banner/script-sunset-banner.component";

@Component({
  imports: [
    ScriptCardComponent,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    RouterLink,
    ScriptSunsetBannerComponent
],
  templateUrl: './creations.component.html',
  styleUrl: './creations.component.less'
})
export class CreationsComponent {
  scriptService = inject(ScriptService);
  accountService = inject(AccountService);
  router = inject(Router);

  ngOnInit() {
    this.accountService.account.subscribe(account => {
      if (account !== undefined && (account === null || !account.staff)) {
        this.router.navigate(['/scripts/sunsetting-info']);
      }
    });
  }

  get scripts() {
    console.log("Own scripts:", this.scriptService.ownScripts);
    return this.scriptService.ownScripts;
  }

  get isCreationAllowed() {
    return ScriptService.isCreationAllowed() || this.accountService.account.value?.staff === true;
  }

  isScriptAccessible(script: any): boolean {
    // If it's only drafts, it's subject to the creation deadline
    if (script.isOnlyDrafts && !this.isCreationAllowed) {
      return false;
    }
    return true;
  }
}
